import React from 'react';
import { ButtonWrapper, LoginRegisterCont } from './LoginRegister.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { Button, IconButton, styled } from '@material-ui/core';
import { CONFIG } from 'shared/config';
import { ls } from 'shared/utils/ls';
import { CloseIcon, WarningCircleFilledIcon } from '@room-match/shared-ui-components';
import { COLORS } from '@room-match/shared-ui-components/utils/COLORS';

interface Props {
  close: VoidFunction;
}

export const Header = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',

  '& svg': {
    height: '20px',
    width: '20px',

    '& path': {
      fill: COLORS.DARK,
    },
  },
}));

const LoginRegister: React.FC<Props> = ({ close }) => {
  const { getLS } = ls();
  const handleButtonClick = (type: 'login' | 'register') => {
    const { casting_role_id, project_id, company_name, role_name } = JSON.parse(getLS('pending_job_application'));
    if (type === 'login') {
      window.open(
        `${CONFIG.TALENT_APP_URL}/login/?project_id=${project_id}&role_id=${casting_role_id}&company_name=${company_name}&role_name=${role_name}`,
        '_blank',
      );
    } else {
      window.open(
        `${CONFIG.TALENT_APP_URL}/signup/?project_id=${project_id}&role_id=${casting_role_id}&company_name=${company_name}&role_name=${role_name}`,
        '_blank',
      );
    }
  };

  return (
    <LoginRegisterCont>
      <Header>
        <IconButton>
          <CloseIcon fontSize="small" onClick={() => close()} />
        </IconButton>
      </Header>
      <WarningCircleFilledIcon />
      <CustomTypography style={{ textAlign: 'center', fontWeight: 600, fontSize: 18 }}>
        You're almost there!
      </CustomTypography>

      <CustomTypography style={{ textAlign: 'center' }}>
        Please log in to complete this action. If you haven't registered yet, create an account to submit.
      </CustomTypography>

      <ButtonWrapper>
        <Button onClick={() => handleButtonClick('register')} variant="outlined" color="primary" fullWidth>
          Register
        </Button>
        <Button onClick={() => handleButtonClick('login')} variant="contained" color="primary" fullWidth>
          Login
        </Button>
      </ButtonWrapper>
    </LoginRegisterCont>
  );
};

export default LoginRegister;
